<template>
  <div class="relative h-full w-full">
    <div :class="gridClasses">
      <div
        v-for="index in 4"
        :key="index"
        class="bg-primary-200"
        :class="gridItemClasses"
      />
    </div>

    <!--    <div-->
    <!--      class="absolute -inset-1 scale-50 rounded bg-primary-100 opacity-0 transition group-hover:scale-100 group-hover:opacity-100"-->
    <!--    />-->

    <app-fade-transition appear>
      <div
        v-if="selection.length > 0"
        class="absolute inset-0"
        :class="gridClasses"
      >
        <app-image
          v-for="teacher in selection"
          :key="teacher.id"
          :alt="teacher.full_name!"
          class="object-cover"
          :class="gridItemClasses"
          :height="100"
          :src="teacher.avatar_url"
          :width="100"
        />
      </div>
    </app-fade-transition>

    <div class="absolute inset-0 grid place-content-center">
      <teacher-pinned-icon
        class="rounded-full bg-white p-1 transition group-hover:scale-50 group-hover:opacity-0"
        :size="22"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { data } = useTeacherList(
  "pinned_teachers",
  {
    pinned: true,
    limit: 15,
  },
  {
    server: false,
    lazy: true,
    dedupe: "defer",
  },
);

const selection = computed(() => shuffle(data.value).slice(0, 4));

const gridClasses = "grid h-full w-full grid-cols-2 grid-rows-2 gap-1";
const gridItemClasses = "transition aspect-square rounded-sm";
</script>
